export default __webpack_public_path__ + "static/me-5348ba9bd84dfd60e4899b69f0dff1f2.jpg";